import styled from 'styled-components';
import ButtonLink from '../shared/ButtonLinkComponent';
import SvgFromFilePath from '../shared/SvgFromFilePath';
import WidgetIdWrapper from '../shared/WidgetIdWrapper';
import { device } from '../../utils/styled-component-mixins';
import { withWidgetSpacingWrapper } from '../shared/WidgetSpacingWrapper';

const BannerWithIconsStyled = styled.div`
  ${(props) =>
    props.backgroundImage && `background: url("${props.backgroundImage}") center/cover no-repeat;`}
  ${(props) => props.theme === 'dark' && 'color: var(--white);'}
  padding: 22.5rem 4rem 4rem 4rem;

  @media ${device.desktop} {
    align-items: flex-start;
    display: flex;
    justify-content: space-between;
    padding: 10rem 11rem 10rem 20rem;
  }

  .banner-content {
    @media ${device.desktop} {
      flex: 0 0 40%;
      min-width: 31.5rem;
    }

    @media ${device.desktopLg} {
      flex: 0 0 20%;
      margin-bottom: 5rem;
    }

    .btn-wrapper {
      justify-content: center;
      display: flex;
      margin-bottom: 4rem;

      @media ${device.desktop} {
        justify-content: flex-start;
      }

      .btn-primary {
        text-align: center;
        width: 100%;

        @media ${device.tablet} {
          width: auto;
        }
      }
    }
  }

  .banner-description {
    margin-bottom: 5.6rem;
    margin-left: auto;
    margin-right: auto;
    max-width: 40rem;
    text-align: center;

    @media ${device.desktop} {
      margin-left: 0;
      margin-right: 0;
      text-align: left;
    }
  }

  h2 {
    margin-bottom: 1.6rem;
    text-align: center;

    @media ${device.desktop} {
      text-align: left;
    }
  }
`;

const IconsStyled = styled.ul.attrs((props) => ({
  className: props.className
}))`
  column-gap: 2.4rem;
  display: none;
  list-style: none;
  margin: 0;
  padding: 0;
  row-gap: 2.4rem;
  list-style: none;
  margin: 0;
  padding: 0;

  li {
    &::before {
      content: none;
    }
  }

  @media ${device.desktop} {
    display: flex;
    justify-content: center;
    flex: 0 1 50%;
    flex-wrap: wrap;
    margin-left: 10%;
  }

  @media ${device.desktopLg} {
    margin: auto 0 0 0;
  }

  li {
    align-items: center;
    display: flex;
    flex-direction: column;
    width: 45%;

    @media ${device.desktopLg} {
      width: 20%;
    }

    span {
      display: block;
      font-size: 2rem;
      font-weight: 400;
      line-height: 3.2rem;
      margin-top: 2.4rem;
      text-align: center;
    }
  }

  svg {
    ${(props) => (props.theme === 'dark' ? 'fill: var(--white);' : 'fill: var(--slate);')}
    width: 100%;
    max-height: 10rem;
    max-width: 10rem;

    @media ${device.desktopLg} {
      max-height: 10rem;
      max-width: 10rem;
    }
  }
`;

const BannerWithIconsComponent = (props) => {
  const {
    backgroundImage,
    description,
    firstCtaLinkText,
    firstCtaLinkType,
    firstCtaLinkUrl,
    firstCtaLinkIcon,
    firstIcon,
    firstIconLabel,
    fourthIcon,
    fourthIconLabel,
    primaryCtaText,
    primaryCtaType,
    primaryCtaUrl,
    primaryCtaIcon,
    secondCtaLinkText,
    secondCtaLinkType,
    secondCtaLinkUrl,
    secondCtaLinkIcon,
    secondIcon,
    secondIconLabel,
    thirdIcon,
    thirdIconLabel,
    title,
    widgetID,
    theme
  } = props;

  return (
    <WidgetIdWrapper widgetID={widgetID}>
      <BannerWithIconsStyled backgroundImage={backgroundImage} theme={theme}>
        <div className="banner-content">
          <h2>{title}</h2>
          <div className="banner-description" dangerouslySetInnerHTML={{ __html: description }} />
          {primaryCtaText && (
            <ButtonLink
              link={primaryCtaUrl}
              type={primaryCtaType}
              text={primaryCtaText}
              icon={primaryCtaIcon}
              theme={theme}
            />
          )}
          {firstCtaLinkText && (
            <ButtonLink
              link={firstCtaLinkUrl}
              type={firstCtaLinkType}
              text={firstCtaLinkText}
              icon={firstCtaLinkIcon}
              theme={theme}
            />
          )}
          {secondCtaLinkText && (
            <ButtonLink
              link={secondCtaLinkUrl}
              type={secondCtaLinkType}
              text={secondCtaLinkText}
              icon={secondCtaLinkIcon}
              theme={theme}
            />
          )}
        </div>
        <IconsStyled className="non-bdo-style-list" theme={theme}>
          {firstIcon && (
            <li>
              <SvgFromFilePath path={firstIcon} />
              <span>{firstIconLabel}</span>
            </li>
          )}
          {secondIcon && (
            <li>
              <SvgFromFilePath path={secondIcon} />
              <span>{secondIconLabel}</span>
            </li>
          )}
          {thirdIcon && (
            <li>
              <SvgFromFilePath path={thirdIcon} />
              <span>{thirdIconLabel}</span>
            </li>
          )}
          {fourthIcon && (
            <li>
              <SvgFromFilePath path={fourthIcon} />
              <span>{fourthIconLabel}</span>
            </li>
          )}
        </IconsStyled>
      </BannerWithIconsStyled>
    </WidgetIdWrapper>
  );
};

export default withWidgetSpacingWrapper(BannerWithIconsComponent);
